import React from 'react';
import { useHistory } from 'react-router-dom';
import './ComingSoonDashboard.css';

const GrokDashboard = () => {
  const history = useHistory();

  return (
    <div className="coming-soon-dashboard">
      <div className="coming-soon-content">
        <div className="dashboard-icon-large">⚡</div>
        <h1>Grok Dashboard</h1>
        <p className="coming-soon-message">This dashboard is coming soon!</p>
        <p className="description">
          View and analyze your Grok AI usage statistics and performance metrics.
        </p>
        <button onClick={() => history.push('/main_app')} className="back-button">
          ← Back to Dashboard Selection
        </button>
      </div>
    </div>
  );
};

export default GrokDashboard;
